export default __webpack_public_path__ + "static/10-4b7a903acf0443c7ba5dd377ad8c898a.png";